import request from '../utils/request';
export function fetchPromoCodeUsages(filters) {
    const params = new URLSearchParams();
    const search = filters?.search?.trim();
    const createdAtFrom = filters?.created_at_from;
    const createdAtTo = filters?.created_at_to;
    if (search)
        params.append('search', search);
    if (createdAtFrom)
        params.append('created_at_from', createdAtFrom);
    if (createdAtTo)
        params.append('created_at_to', createdAtTo);
    const queryString = params.toString();
    const url = queryString
        ? `/api/v1/admin/promo-code-usages/?${queryString}`
        : '/api/v1/admin/promo-code-usages/';
    return request()
        .get(url)
        .send();
}
export function deletePromoCodeUsage(id) {
    return request()
        .delete(`/api/v1/admin/promo-code-usages/${id}/`)
        .send();
}
